import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { jwtDecode } from 'jwt-decode';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: 'https://api.codebondingworkforce.com/api',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ['Payments'],
  endpoints: (builder) => ({
       getPayments: builder.query({
      query: ({ page = 1, limit = 10, search = '' }) => 
        `/payments?page=${page}&limit=${limit}&search=${search}`,
      providesTags: ['Payments'],
      transformResponse: (response) => ({
        payments: response.payments,
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages,
          totalRecords: response.totalRecords
        }
      })
    }),
    approvePayment: builder.mutation({
      query: (paymentId) => {
        const token = localStorage.getItem('accessToken');
        const decoded = jwtDecode(token);
        return {
          url: `/payments/approve/${paymentId}`,
          method: 'POST',
          body: { adminId: decoded.adminId }
        };
      },
      invalidatesTags: ['Payments']
    }),
    rejectPayment: builder.mutation({
      query: ({ paymentId, rejectionReason }) => {
        const token = localStorage.getItem('accessToken');
        const decoded = jwtDecode(token);
        return {
          url: `/payments/reject/${paymentId}`,
          method: 'POST',
          body: { 
            status: 'rejected',
            rejectionReason,
            adminId: decoded.adminId
          }
        };
      },
      invalidatesTags: ['Payments']
    })
  })
});

export const { 
  useGetPaymentsQuery,
  useApprovePaymentMutation,
  useRejectPaymentMutation
} = paymentApi;